export default __webpack_public_path__ + "static/media/CL.905c2019.svg";